const adminIds = ["820795610189135902", "262272981072347137"]; // Replace with actual IDs
module.exports = adminIds;